// extracted by mini-css-extract-plugin
export default {"overallResults":"OverallResults_overallResults__x5ZKF","wrapTable":"OverallResults_wrapTable__1WAJV","btn":"OverallResults_btn__qJCUi","btnPrint":"OverallResults_btnPrint__UBk7x"};